/**
 * The one-click send's letter, as the shared send confirmation shows it.
 *
 * Pure, so the one rule here is readable on its own: a letter that will NOT
 * leave (no address, the client switched mail off) says so in the note, in
 * place of the signature line, because that is the thing the operator must
 * not miss before pressing Send.
 */
import type { SalesSendPreview } from "../../../lib/sales";
import type { SendPreview } from "../../mail/SendConfirmModal";

export function sendPreviewFor(p: SalesSendPreview, t: (key: string) => string): SendPreview {
  return {
    from: p.from ?? t("sales.sendPreview.noSender"),
    to: p.to ? [p.to] : [],
    subject: p.subject,
    bodyHtml: p.html,
    attachments: [p.attachment],
    note: p.reason ? t(`sales.sendPreview.${p.reason}`) : p.signed ? t("sendConfirm.signatureNote") : undefined,
  };
}
